import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  InputBase,
  Box,
  Tooltip,
} from '@mui/material';
import { Add, Search, Close } from '@mui/icons-material';
import MainContentContainer from "../../MainContentContainer/MainContentContainer";
import AuthorsTable from "./../../AuthorsTable/AuthorsTable";

const AuthorsPage = () => {
  const searchInputRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'f' && e.shiftKey) {
        e.preventDefault();
        if (!isSearchOpen) {
          handleToggleSearch();
        }
      }
      if (e.key === 'Escape' && isSearchOpen) {
        e.preventDefault();
        handleToggleSearch();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isSearchOpen]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleToggleSearch = () => {
    setIsSearchOpen((prev) => !prev);
    if (isSearchOpen) {
      setSearchText("");
    } else {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
    }
  };

  return (
    <MainContentContainer>
      <AppBar position="sticky">
        <Toolbar>
          {isSearchOpen ? (
            <Box display="flex" alignItems="center" flexGrow={1}>
              <InputBase
                inputRef={searchInputRef}
                value={searchText}
                onChange={handleSearchChange}
                sx={{
                  flexGrow: 1,
                  px: 2,
                  py: 1,
                  backgroundColor: "white",
                  borderRadius: 1,
                  '& input': {
                    color: 'text.primary',
                  }
                }}
                placeholder="Search authors..."
              />
              <IconButton color="inherit" onClick={handleToggleSearch}>
                <Close />
              </IconButton>
            </Box>
          ) : (
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Authors
            </Typography>
          )}
          <Tooltip title="Search (⌘F)">
            <IconButton color="inherit" onClick={handleToggleSearch}>
              <Search />
            </IconButton>
          </Tooltip>
          <Button
            color="inherit"
            component={Link}
            to="/authors/add"
            startIcon={<Add />}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Add Author
          </Button>
        </Toolbar>
      </AppBar>
      <AuthorsTable searchText={searchText} />
    </MainContentContainer>
  );
};

export default AuthorsPage;
